// extracted by mini-css-extract-plugin
export default {"cta":"yI-z","disabled":"zI-z"};